import { ActionsHandler } from "components";
import React, { useEffect, useRef } from "react";
import { ScriptStatus } from "@nf/common";

interface ICreditCardIframeProps {
  scriptStatus: string;
  isLoading?: boolean;
  centered?: boolean;
}
const CARD_PAYMENT_FRAME_NAME = "payment-frame";

export const CreditCardIframe = ({
  scriptStatus,
  isLoading,
}: ICreditCardIframeProps) => {
  const cardPaymentFrame = useRef<HTMLDivElement | null>(null);
  const appendIframePayment = () => {
    const iframe: HTMLIFrameElement | null = document.querySelector(
      ".PensioEmbeddedPaymentWindow"
    );

    if (iframe) {
      iframe.style.position = "relative";
      iframe.style.height = "600px";
    }

    const parent = iframe?.parentNode as HTMLDivElement;

    if (iframe && parent?.dataset?.name !== CARD_PAYMENT_FRAME_NAME) {
      cardPaymentFrame.current?.append(iframe);
    }
  };

  useEffect(() => {
    scriptStatus === ScriptStatus.ready && appendIframePayment();
    return () => {
      if (scriptStatus === ScriptStatus.ready) {
        const iframes = document.querySelectorAll(
          ".PensioEmbeddedPaymentWindow"
        );
        iframes.forEach((iframe) => iframe.remove());
        const containers = document.querySelectorAll(
          ".PensioEmbeddedPaymentWindowBackground"
        );
        containers.forEach((container) => container.remove());
      }
    };
  }, [scriptStatus]);

  if (scriptStatus === ScriptStatus.idle && !isLoading) {
    return null;
  }
  return (
    <>
      <ActionsHandler
        isLoading={scriptStatus === ScriptStatus.loading || isLoading}
        error={scriptStatus === ScriptStatus.error ? {} : undefined}
      />
      <div
        ref={cardPaymentFrame}
        data-name={CARD_PAYMENT_FRAME_NAME}
        style={{ position: "relative", minHeight: "700px", width: "100%" }}
      />
    </>
  );
};
